module.exports = __webpack_public_path__ + "img/52002749_L.826c4c9d.png";